<template>
    <div class="blog-newsletter">
        <div class="container">
            <div class="blog-newsletter__content">
                <p class="blog-newsletter__text">Assine nossa newsletter</p>
                <input v-model="form.nome" minlength="3" class="blog-newsletter__input" placeholder="Seu nome" type="text">
                <input v-model="form.email" minlength="5" class="blog-newsletter__input" placeholder="Seu e-mail" type="email">
                <button @click="sendNews" class="blog-newsletter__btn" type="submit">{{buttonText}}</button>
            </div>
            <ModalConfirm :show="show" :msg="msg"/>
        </div>
    </div>
</template>

<script>
    import ModalConfirm from "../../Shared/ModalConfirm";

    export default {
        name: "BlogNewsletter",
        data() {
            return {
                form: {
                    nome: '',
                    email: '',
                },
                msg: '',
                show: false,
                buttonText: 'Enviar',
            }
        },
        components: {
            ModalConfirm
        },
        methods: {
            sendNews(e) {
                e.preventDefault();
                this.buttonText = 'Enviando...';
                axios.post('/newsletter', this.form)
                    .then(() => {
                        this.show = true;
                        this.msg = 'Seu e-mail foi adicionado a nossa newsletter.';
                        setTimeout(() => {
                            this.show = false;
                            this.buttonText = 'Enviar';
                            this.form.email = '';
                            this.form.nome = '';
                        }, 2000)
                    })
                    .catch(() => {
                        this.show = true;
                        this.buttonText = 'Enviar';
                        this.msg = 'Houve um erro ao adicionar o e-mail.';
                        setTimeout(() => {
                            this.show = false;
                        }, 2000)
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .blog-newsletter {
        width: 100%;
        background: #2b2b2b;
        color: #fff;
        padding: 24px 0;

        &__content {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        &__text {
            flex-shrink: 0;
            margin-right: 30px;
            font-family: "Open Sans";
            font-weight: 400;
            font-size: 1.25rem;
        }

        &__input {
            width: 100%;
            margin-right: 30px;
            padding: 15px;
            border-radius: 4px;
            border: none;
            font-size: 1rem;

            &::placeholder {
                color: #2b2b2b;
                font-family: "Open Sans";
                font-size: 0.875rem;
                color: #aaa;
            }
        }

        &__btn {
            border-radius: 24px;
            border: 1px solid #fff;
            flex-shrink: 0;
            padding: 0.75rem 4rem;
            font-family: Poppins, Arial, sans-serif;
            font-size: 0.875rem;
            background: transparent;
            color: #fff;
            position: relative;
            z-index: 0;
            overflow: hidden;
            cursor: pointer;
            outline: none;

            &::before {
                position: absolute;
                top: 0;
                left: 0;
                content: '';
                display: block;
                height: 100%;
                width: 100%;
                background: #fff;
                z-index: -1;
                transition: all .3s;
                transform: translate3d(0, 100%, 0);
            }
        }
    }

    .blog-newsletter__btn:hover {
        color: #000;
    }

    .blog-newsletter__btn:hover.blog-newsletter__btn::before {
        transform: translate3d(0, 0, 0);
    }

    @media only screen and(max-width: 768px) {
        .blog-newsletter__text {
            font-size: 0.875rem;
        }

        .blog-newsletter__btn {
            padding: 0.75rem 2.5rem;
            font-size: 0.875rem;
        }
    }

    @media only screen and(max-width: 767px) {
        .blog-newsletter {
            &__text {
                margin-right: 0;
                margin-bottom: 15px;
                font-size: 1rem;
            }

            &__input {
                margin-right: 0;
                margin-bottom: 10px;
            }

            &__btn {
                margin-top: 20px;
            }
        }

        .blog-newsletter__content {
            flex-direction: column;
            justify-content: center;
        }
    }
</style>